// eslint-disable-next-line
import React, { useCallback, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { MarzipanoLoader } from './MarzipanoLoader';
import { LoadingLogo } from './LoadingLogo/LoadingLogo';
import { getIsAssetLoaded, getProcedureLoaded } from '../features/globals/visibilitySlice';
import { getConfig } from '../features/config/configSlice';

const GeminiLoader = ({ onLoaded }) => {
    const isAssetLoaded = useSelector(getIsAssetLoaded);
    const isProcedureLoaded = useSelector(getProcedureLoaded);
    const config = useSelector(getConfig);
    const [isInitializing, setIsInitializing] = useState(true);
    const [hasLoadError, setHasLoadError] = useState(false);

    const handleLoaded = useCallback(() => {
        setHasLoadError(false);
        setIsInitializing(false);
        if (onLoaded) {
            onLoaded();
        }
    }, [onLoaded]);

    const handleError = useCallback(() => {
        setHasLoadError(true);
        setIsInitializing(false);
    }, []);

    const isAuthorMode = config?.modeType === 'author';
    const showEmptyState = !isAuthorMode && !isInitializing && (hasLoadError || (!isProcedureLoaded && !isAssetLoaded));

    return (
        <>
            <MarzipanoLoader onLoaded={handleLoaded} onError={handleError} />

            {isInitializing && config.modeType === 'viewer' && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        pointerEvents: 'none',
                        zIndex: 2,
                    }}
                >
                    <Box sx={{ transform: 'scale(5)', transformOrigin: 'center', mb: 8 }}>
                        <LoadingLogo styleClassName={undefined} rotateClassName={undefined} />
                    </Box>
                    <Typography sx={{ mt: 1, color: 'text.primary', fontWeight: 500, textAlign: 'center' }}>
                        One moment while we launch your application.
                    </Typography>
                </Box>
            )}

            {showEmptyState && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 2,
                        pointerEvents: 'none',
                    }}
                >
                    <Typography sx={{ color: 'text.primary', fontWeight: 500, textAlign: 'center' }}>
                        There are not asset or procedure.
                    </Typography>
                </Box>
            )}
        </>
    );
};

export { GeminiLoader };
